<ng-container *ngIf="data?.topics?.length && !loading">
    <div class="topics-table-container">
        <ag-grid-angular
            class="topics-table-grid ag-theme-alpine"
            style="width: 100%; height: auto;"
            [rowData]="rowData?.topics"
            [columnDefs]="colDefs"
            [modules]="modules"
            [theme]="theme"
            [gridOptions]="gridOptions"
            (gridReady)="onGridReady($event)">
        </ag-grid-angular>
    </div>
</ng-container>
<app-no-widget-data *ngIf="!this.data?.topics?.length && !loading"></app-no-widget-data>
<app-loader *ngIf="loading"></app-loader>